import React from "react";
import RenderChildrenWrapper from "../../../common/RenderChildrenWrapper";
import styles from "./levelDiamond.module.scss";
/** Whether any requirement of this level is suppressed by a user override —
 * what the `*` markers in the tooltip's statements, and the note the card's
 * footer carries, both refer to. */
export const hasLevelUserOverrides = (levelsInfo, inhibitors, level) => {
    var _a, _b;
    return (_b = (_a = levelsInfo[`L${level}`]) === null || _a === void 0 ? void 0 : _a.some((levelLabel) => levelLabel.policies.some((policyId) => inhibitors.exclusions[policyId] !== undefined))) !== null && _b !== void 0 ? _b : false;
};
const getLabelPolicyViolations = (policyList, statistics, shouldEnforce) => {
    return policyList.reduce((acc, policyId) => {
        if (statistics && statistics[policyId]) {
            const count = shouldEnforce
                ? statistics[policyId].enforcements
                : statistics[policyId].violations;
            return { ...acc, [policyId]: count };
        }
        else {
            return acc;
        }
    }, {});
};
const Label = ({ level, inhibitors, statistics, levelLabel, labelLinkWrapper, }) => {
    const labelPolicies = getLabelPolicyViolations(levelLabel.policies, statistics, level <= inhibitors.scan_level);
    const labelCount = Object.values(labelPolicies).reduce((acc, count) => count + acc, 0);
    const hasUserOverrides = levelLabel.policies.some((policyId) => inhibitors.exclusions[policyId] !== undefined);
    return (React.createElement("div", { key: levelLabel.id, id: levelLabel.id },
        labelCount > 0 ? (React.createElement(RenderChildrenWrapper, { wrapper: labelLinkWrapper &&
                ((children) => labelLinkWrapper(levelLabel.id, Object.keys(labelPolicies), "fail", children)) }, labelCount.toLocaleString())) : ("No"),
        " ",
        levelLabel.label,
        " ",
        hasUserOverrides && (React.createElement("span", { className: styles["tooltip-label-warning"] }, "*"))));
};
const DiamondTooltip = ({ level, inhibitors, statistics, levelsInfo, labelLinkWrapper, }) => {
    if (!levelsInfo)
        return React.createElement(React.Fragment, null, "No information");
    // The note about those overrides is the card's footer, which LevelDiamond
    // owns — the body states requirements only.
    return (React.createElement("div", { className: styles["tooltip-content"] }, levelsInfo[`L${level}`].map((levelLabel) => (React.createElement(Label, { key: levelLabel.id, level: level, inhibitors: inhibitors, statistics: statistics, levelLabel: levelLabel, labelLinkWrapper: labelLinkWrapper })))));
};
export default DiamondTooltip;
//# sourceMappingURL=DiamondTooltip.js.map